import React from 'react';

const SlotWrapper = ({ 
  children, 
  className = '',
  ...props 
}) => {
  return (
    <div 
      className={`bubble-slot-wrapper flex w-full flex-col items-start mb-v3-sm ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default SlotWrapper;
